<template>
 <div>
   <router-link :to="{path:'/details', query:{ goods_id:item.id }}" class="v_boxleftbtnson" v-for="(item,index) in shoplist" :key="index">
    <img :src="imgurl + item.skus[0].image" class="v_boxleftbtnsonimg">
    <div class="v_boxleftbtnsonmoney txtnowarp">
      <span>￥</span>{{item.skus[0].shop_price}}
    </div>
    <div class="v_boxleftbtnsoname txtnowarp2">
      {{item.title}}
    </div>
    <div class="v_boxleftbtnsonnum txtnowarp">
      库存<span>{{Number(item.skus[0].stock) + Number(item.skus[0].virtual_inventory) - Number(item.skus[0].virtual_occupy)}}</span>件
    </div>
   </router-link>
 </div>
</template>
<script>
    export default {
        props: {
            shoplist: {
//				type: Array,
				default() {
					return [];
				}
			}
        },
        data() {
            return {
				imgurl:'',
            }
        },
        created() {
			let that = this;
			that.imgurl = that.$publicUrl.http1;
			

		},
    }
</script>
<style scoped>
    .v_boxleftbtnson {
        width: 100%;
        height: 265px;
        box-sizing: border-box;
        padding: 0 20px;
        border: 1px solid #dddddd;
        display: inline-block;
        margin-bottom: 10px;
    }
    
    .v_boxleftbtnson:hover {
        border: 1px solid #dc1e33;
    }
    
    .v_boxleftbtnsonimg {
        width: 100%;
        display: block;
        object-fit: scale-down;
        height: 140px;
    }
    
    .v_boxleftbtnsoname {
        width: 100%;
        height: 50px;
        line-height: 25px;
        font-size: 14px;
    }
    
    .v_boxleftbtnsonmoney {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        color: #dc1e33;
    }
    
    .v_boxleftbtnsonmoney span {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
    }
    
    .v_boxleftbtnsonnum {
        width: 100%;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
    }
    
    .v_boxleftbtnsonnum span {
        display: inline-block;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #1078d8;
    }
</style>